import { motion } from "framer-motion";
import founderPhoto from "@/assets/luiza-sotsek.jpeg";

export const Founder = () => {
  return (
    <section id="socia-fundadora" className="py-16 lg:py-24 bg-card/50">
      <div className="container mx-auto px-6 lg:px-12">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <h2 className="font-serif text-3xl lg:text-4xl font-bold text-foreground">
            Sócia <span className="text-primary">Fundadora</span>
          </h2>
        </motion.div>

        {/* Founder Content */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, delay: 0.2 }}
          className="max-w-4xl mx-auto"
        >
          <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12">
            {/* Photo */}
            <div className="flex-shrink-0">
              <div className="w-64 h-64 lg:w-80 lg:h-80 rounded-2xl overflow-hidden shadow-xl border-4 border-primary/20">
                <img
                  src={founderPhoto}
                  alt="Luiza Sotsek - Sócia Fundadora"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>

            {/* Info */}
            <div className="flex-1 text-center lg:text-left">
              <h3 className="font-serif text-2xl lg:text-3xl font-bold text-foreground mb-2">
                Luiza Sotsek
              </h3>
              <p className="text-primary font-medium text-lg mb-6">
                Sócia Fundadora
              </p>
              <p className="text-muted-foreground leading-relaxed text-base lg:text-lg">
                Advogada com atuação pautada pelo rigor técnico, pela ética e pela responsabilidade 
                na condução de cada demanda. Seu trabalho é orientado por análise criteriosa, tomada 
                de decisões conscientes e absoluto respeito à segurança jurídica, oferecendo ao cliente 
                clareza, previsibilidade e confiança em todas as etapas do atendimento.
              </p>
              <p className="text-muted-foreground leading-relaxed text-base lg:text-lg mt-4">
                É reconhecida pela postura profissional, comunicação objetiva e atendimento próximo, 
                garantindo transparência quanto a riscos, prazos e alternativas possíveis. Como sócia 
                fundadora, conduz o escritório com seriedade, comprometimento e foco em soluções 
                juridicamente sólidas e duradouras.
              </p>
              <p className="text-muted-foreground leading-relaxed text-base lg:text-lg mt-4">
                Profundo conhecimento técnico obtido a partir de anos de experiência junto ao 
                Tribunal de Justiça, assessorando Juízes e Desembargadores.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};
